import React from 'react'
import GoogleSheetEmbed from './GoogleSheetEmbed'

const TopOffer = () => {
  return (
    <div>
        <GoogleSheetEmbed/>
    </div>
  )
}

export default TopOffer